// import React from 'react'
// import HomeCategoryCard from './HomeCategoryCard'
// import { useAppSelector } from '../../../../Redux Toolkit/Store';

// const homeCategory=[
//   {
//     "name": "Alphabet Beads",
//     "categoryId": "alphabed_beads",
//     "parentCategoryName": "Glass Seed Beads",
//     "parentCategoryId": "glass_seed_beads",
    
//     "level": 2,
//     "section":"SHOP_BY_CATEGORIES",
//     image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/28460938/2024/3/22/7fb09e9c-86e0-4602-b54e-fa5c0171b50b1711104156746IrregularMirrorHomeDecor1.jpg"
//   },
//   {
//     "name": "Kitchen & Table 11",
//     "categoryId": "kitchen_table",
//     "parentCategoryName": "Furniture",
//     "parentCategoryId": "furniture",
    
//     "level": 2,
//     "section":"SHOP_BY_CATEGORIES",
//     image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19873492/2022/9/10/fd72939c-c379-4bab-9fd6-918c89172d161662797928387AquarelleBlue100CottonPrintedTableRunner1.jpg"
//   },

//   {
//     "parentCategoryId":"women",
//     "level":2,
//     "name":"Sports & Active Wear",
//     "categoryId": "women_sports_active_wear",
//     "section":"SHOP_BY_CATEGORIES",
//     image:"https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/22109480/2023/9/5/06a17ac3-46b0-4f9d-bcb1-2d3582feda041693895310152PumaWomenBrandLogoPrintedPureCottonOutdoorT-shirt1.jpg"
//   },
//   {
//     "parentCategoryId":"women",
//     "level":2,
//     "name":"Lingerie Sleepwear",
//     "categoryId": "women_lingerie_sleepwear",
//     "section":"SHOP_BY_CATEGORIES",
//     image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/362895/2023/10/18/bfb55058-fe1a-45d6-a39d-1b8d421e02001697603774147TriumphShapeSensation33withHighWaistTummyandThighControlMaxi1.jpg"
//   },

//     {
//       "parentCategoryId":"women",
//       "level":2,
//       "name":"Indian & fusion Wear",
//       "categoryId": "women_indian_and_fusion_wear",
//       "section":"SHOP_BY_CATEGORIES",
//       image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22866694/2023/4/24/98951db4-e0a5-47f8-a1be-353863d24dc01682349679664KaliniOrangeSilkBlendEthnicWovenDesignFestiveSareewithMatchi2.jpg"
//     },
//     {
//       "parentCategoryId":"women",
//       "level":2,
//       "name":"western wear",
//       "categoryId": "women_western_wear",
//       "section":"SHOP_BY_CATEGORIES",
//       image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22391504/2023/3/17/3259c109-060a-4c39-aba2-e9d32e2068e41679049035856StyleQuotientPeach-ColouredTie-UpNeckPuffSleeveCottonTop1.jpg"
//     },
//     {
//       "parentCategoryId":"women",
//       "level":2,
//       "name":"Women Footwear",
//       "categoryId": "women_footwear",
//       "section":"SHOP_BY_CATEGORIES",
//       image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/28024048/2024/3/5/fca98389-f9d6-4f19-b82a-53c7ee0518ec1709633175836CORSICABlockSandalswithBows1.jpg"
//     },
//     {
//         "name": "Topwere",
//         "categoryId": "men_topwear",
//         "parentCategoryId":"men",
//         "level":2,
//         "section":"SHOP_BY_CATEGORIES",
//         image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/23029834/2023/9/18/96c015ae-1090-4036-954b-d9c80085b1d71695022844653-HRX-by-Hrithik-Roshan-Men-Jackets-6981695022843934-1.jpg"
//     },
//     {
//         "name": "Bottomwere",
//         "categoryId": "men_bottomwear",
//         "parentCategoryId":"men",
//         "level":2,
//         "section":"SHOP_BY_CATEGORIES",
//         image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/20122324/2022/9/22/91c61c45-fe17-4d1d-8e20-0aaaf90186b61663827920015RaymondSlimFitBlueJeansForMen1.jpg"
//     },
//     {
//         "name": "Innerwere And Sleepwere",
//         "categoryId": "men_innerwear_and_sleepwear",
//         "parentCategoryId":"men",
//         "level":2,
//         "section":"SHOP_BY_CATEGORIES",
//         image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/24528350/2023/8/17/d9ee03c9-7e15-49e4-8f15-0b6f38e568121692275415567TrackPants1.jpg"
//     },
//     {
//         "name": "Footwere",
//         "categoryId": "men_footwear",
//         "parentCategoryId":"men",
//         "level":2,
//         "section":"SHOP_BY_CATEGORIES",
//         image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/27107914/2024/1/30/bd09f650-d8a4-4570-8e53-e2cfafc4ea6c1706609911015SparxMenMeshRunningShoes1.jpg"
//     },
//     {
//       "name": "Bed Linen & Furnishing",
//       "categoryId": "bed_linen_furnishing",
//       "parentCategoryName": "Furniture",
//       "parentCategoryId": "furniture",
      
//       "level": 2,
//       "section":"SHOP_BY_CATEGORIES",
//       image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19284508/2022/7/28/92df52de-27dc-4d72-8ab4-fee2c82c85081659003977664DreamscapeUnisexPinkBedsheets1.jpg"
//     },
//     {
//       "name": "Flooring",
//       "categoryId": "flooring",
//       "parentCategoryName": "Furniture",
//       "parentCategoryId": "furniture",
      
//       "level": 2,
//       "section":"SHOP_BY_CATEGORIES",
//       image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/27868878/2024/2/25/53b7c07f-24a7-48e2-a791-f63dce4a0c981708844793060SANACARPETMulticolouredFloralAnti-SkidPolyesterCarpet1.jpg"
//     },
//     {
//       "name": "Bath",
//       "categoryId": "bath",
//       "parentCategoryName": "Furniture",
//       "parentCategoryId": "furniture",
      
//       "level": 2,
//       "section":"SHOP_BY_CATEGORIES",
//       image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16719378/2024/7/2/97418bad-8216-494f-a863-9b159aec93cf1719897710069JockeyPackof2CottonTerry500GSMUltrasoftandDurableSolidHandTo1.jpg"
//     },
//     {
//       "name": "Lamps & Lighting",
//       "categoryId": "lamps_lighting",
//       "parentCategoryName": "Furniture",
//       "parentCategoryId": "furniture",
      
//       "level": 2,
//       "section":"SHOP_BY_CATEGORIES",
//       image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/productimage/2021/6/10/5be80654-037c-4591-99c9-a403646971981623344562713-1.jpg"
//     },
//     {
//       "name": "Footwere",
//       "categoryId": "men_footwear",
//       "parentCategoryId":"men",
//       "level":2,
//       "section":"SHOP_BY_CATEGORIES",
//       image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/27107914/2024/1/30/bd09f650-d8a4-4570-8e53-e2cfafc4ea6c1706609911015SparxMenMeshRunningShoes1.jpg"
//   },
//   {
//     "name": "Bed Linen & Furnishing",
//     "categoryId": "bed_linen_furnishing",
//     "parentCategoryName": "Furniture",
//     "parentCategoryId": "furniture",
    
//     "level": 2,
//     "section":"SHOP_BY_CATEGORIES",
//     image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19284508/2022/7/28/92df52de-27dc-4d72-8ab4-fee2c82c85081659003977664DreamscapeUnisexPinkBedsheets1.jpg"
//   },
//   {
//     "name": "Flooring",
//     "categoryId": "flooring",
//     "parentCategoryName": "Furniture",
//     "parentCategoryId": "furniture",
    
//     "level": 2,
//     "section":"SHOP_BY_CATEGORIES",
//     image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/27868878/2024/2/25/53b7c07f-24a7-48e2-a791-f63dce4a0c981708844793060SANACARPETMulticolouredFloralAnti-SkidPolyesterCarpet1.jpg"
//   },
//   {
//     "name": "Bath",
//     "categoryId": "bath",
//     "parentCategoryName": "Furniture",
//     "parentCategoryId": "furniture",
    
//     "level": 2,
//     "section":"SHOP_BY_CATEGORIES",
//     image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16719378/2024/7/2/97418bad-8216-494f-a863-9b159aec93cf1719897710069JockeyPackof2CottonTerry500GSMUltrasoftandDurableSolidHandTo1.jpg"
//   },
//   {
//     "name": "Lamps & Lighting",
//     "categoryId": "lamps_lighting",
//     "parentCategoryName": "Furniture",
//     "parentCategoryId": "furniture",
    
//     "level": 2,
//     "section":"SHOP_BY_CATEGORIES",
//     image:"https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/productimage/2021/6/10/5be80654-037c-4591-99c9-a403646971981623344562713-1.jpg"
//   },
    
  
  
// ]
// const HomeCategory = () => {
//   const { homePage} = useAppSelector((store) => store);
//   return (
//     <div className='flex justify-center gap-7 flex-wrap '>
//         {homePage.homePageData?.shopByCategories.map((item)=><HomeCategoryCard item={item}/>)}
        
//     </div>
//   )
// }

// export default HomeCategory

// Changes for modern website
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../Redux Toolkit/Store";

const HomeCategory = () => {
  const { homePage } = useAppSelector((store) => store);
  const navigate = useNavigate();

  const categories = homePage.homePageData?.shopByCategories || [];

  if (!categories.length) return null;

  return (
    <div className="w-full px-1 sm:px-2 md:px-3 lg:px-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4 md:gap-5">

        {categories.map((item: any, index: number) => (
          <div
            key={item.id || item.categoryId || index}
            onClick={() => navigate(`/products/${item.categoryId}`)}
            className="group cursor-pointer overflow-hidden rounded-[16px] bg-[#061126] shadow-[0_10px_24px_rgba(2,6,23,0.12)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_30px_rgba(2,6,23,0.16)]"
          >
            {/* Image */}
            <div className="overflow-hidden">
              <img
                src={item.image}
                alt={item.name}
                className="h-[150px] sm:h-[165px] md:h-[180px] lg:h-[195px] xl:h-[210px] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>

            {/* Content */}
            <div className="bg-[#061126] px-3 py-3 sm:px-4 sm:py-4 text-white">
              <h3 className="line-clamp-2 text-base sm:text-lg lg:text-xl font-semibold leading-tight">
                {item.name}
              </h3>

              {item.parentCategoryName && (
                <p className="mt-1 text-xs sm:text-sm text-white/70">
                  {item.parentCategoryName}
                </p>
              )}
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default HomeCategory;


// Modernazing website with banner
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { useAppSelector } from "../../../../Redux Toolkit/Store";

// const CategoryCard = ({ item, navigate }: { item: any; navigate: any }) => {
//   return (
//     <div
//       onClick={() => navigate(`/products/${item.categoryId}`)}
//       className="group cursor-pointer overflow-hidden rounded-[16px] bg-[#061126] shadow-[0_10px_24px_rgba(2,6,23,0.12)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_30px_rgba(2,6,23,0.16)]"
//     >
//       <div className="overflow-hidden">
//         <img
//           src={item.image}
//           alt={item.name}
//           className="h-[150px] sm:h-[165px] md:h-[180px] lg:h-[195px] xl:h-[210px] w-full object-cover transition-transform duration-500 group-hover:scale-105"
//         />
//       </div>

//       <div className="bg-[#061126] px-3 py-3 sm:px-4 sm:py-4 text-white">
//         <h3 className="line-clamp-2 text-base sm:text-lg lg:text-xl font-semibold leading-tight">
//           {item.name}
//         </h3>

//         {item.parentCategoryName && (
//           <p className="mt-1 text-xs sm:text-sm text-white/70">
//             {item.parentCategoryName}
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };
// const GridBlock = ({
//   items,
//   navigate,
// }: {
//   items: any[];
//   navigate: any;
// }) => {
//   return (

//     //change the value here to increase or decrease the items in grid
//     <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 gap-3 sm:gap-4 md:gap-5"> 
//       {items.map((item: any, index: number) => (
//         <CategoryCard
//           key={item.id || item.categoryId || index}
//           item={item}
//           navigate={navigate}
//         />
//       ))}
//     </div>
//   );
// };

// const HomeCategory = () => {
//   const { homePage } = useAppSelector((store) => store);
//   const navigate = useNavigate();

//   const categories = homePage.homePageData?.shopByCategories || [];

//   if (!categories.length) return null;

//   const mobileSplitIndex = 6;   // 3 rows × 2 columns
//   const tabletSplitIndex = 9;   // 3 rows × 3 columns
//   const desktopSplitIndex = 20; // 3 rows × 5 columns

//   return (
//     <section className="w-full px-1 sm:px-2 md:px-3 lg:px-4">
//       {/* Mobile + small screens */}
//       <div className="block md:hidden">
//         <GridBlock items={categories.slice(0, mobileSplitIndex)} navigate={navigate} />
//         <GridBlock items={categories.slice(mobileSplitIndex)} navigate={navigate} />
//       </div>

//       {/* Tablet */}
//       <div className="hidden md:block lg:hidden">
//         <GridBlock items={categories.slice(0, tabletSplitIndex)} navigate={navigate} />
//         <GridBlock items={categories.slice(tabletSplitIndex)} navigate={navigate} />
//       </div>

//       {/* Laptop and desktop */}
//       <div className="hidden lg:block">
//         <GridBlock items={categories.slice(0, desktopSplitIndex)} navigate={navigate} />
//         <GridBlock items={categories.slice(desktopSplitIndex)} navigate={navigate} />
//       </div>
//     </section>
//   );
// };

// export default HomeCategory;
